export default __webpack_public_path__ + "static/media/londyn.b3c46fb6.jpg";